import redirect from 'js/lib/coursera.redirect';

import { CheatingIncidentRulings } from 'bundles/academic-integrity/components/program-gradebook/lib/constants';
import type { CheatingIncident } from 'bundles/academic-integrity/components/program-gradebook/lib/types';

export const getCheatingIncidentRoute = (incidentId: string) => {
  return `/integrity-portal/incident/${incidentId}`;
};

export const isCheatingIncidentImpactingLearner = (incident?: CheatingIncident) => {
  return incident && incident.ruling === CheatingIncidentRulings.CheatingConfirmed;
};

export const getCheatingIncidentImpactingLearnerCount = (incidents: CheatingIncident[]) => {
  return incidents.reduce((count, incident) => (isCheatingIncidentImpactingLearner(incident) ? count + 1 : count), 0);
};

export const getMilliSecondsFromGraphqlTimestamp = (timestamp: string) => {
  return new Date(timestamp).getTime();
};

export const onGoToAssignmentClick = (courseSlug: string | undefined, itemId: string | undefined) => {
  return redirect.setLocation(`/learn/${courseSlug}/item/${itemId}`);
};

const getTurnItInLink = async (similarityCheckId: string, programId: string) => {
  const response = await fetch(
    '/api/grpc/enterprisegradebooks/learnerdetails/v1beta1/LearnerDetailsAPI/GenerateSimilarityReport',
    {
      method: 'POST',
      body: JSON.stringify({ similarityCheckId, programId }),
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  if (!response.ok) {
    const errorReason = await response.text();
    throw new Error(`Request failed: ${response.status} ${response.statusText}\n\n${errorReason}`);
  }

  const body = await response.json();

  if (!body?.similarityReport?.url) {
    throw new Error('Request failed: Failed to generate URL');
  }

  return body.similarityReport.url;
};

export const generatePlagiarismLink = (similarityCheckId: string, programId: string) => {
  return () => {
    return getTurnItInLink(similarityCheckId, programId);
  };
};
